import { AxiosError } from 'axios';
import { action, observable, runInAction } from 'mobx';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { UiResponse } from '../CommonInterfaces';
import { API, FetchStatus } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import AccountInfoStore from './AccountInfoStore';
import RootStore from './RootStore';
import RouteStore from './RouteStore';
import UiStore from './UiStore';

export default class EmailRemoveStore {
  @observable accessor removeEmailStatuses: Map<string, FetchStatus> = new Map();
  private routeStore: RouteStore;
  private uiStore: UiStore;
  private accountInfoStore: AccountInfoStore;

  constructor(rootStore: RootStore) {
    this.routeStore = rootStore.routeStore;
    this.uiStore = rootStore.uiStore;
    this.accountInfoStore = rootStore.accountInfoStore;
  }

  public deleteEmail = async (email: string) => {
    try {
      this.removeEmailStatuses.set(email, FetchStatus.FETCHING);
      await API.delete(`/email/start-remove${this.routeStore.formForwardParamsAnd({ email: email, goto: 'account' })}`);
      runInAction(() => {
        this.removeEmailStatuses.set(email, FetchStatus.FETCHED);
      });
      this.accountInfoStore.removeEmailFromList(email);
      this.setSuccessNotice();
    } catch (e: AxiosError<UiResponse> | string | any) {
      this.handleError(e, email);
    }
  };

  private setSuccessNotice = () => {
    this.uiStore.showSuccessNotice('account.email.remove.success');
  };

  @action.bound
  private handleError(e: AxiosError, email: string) {
    ErrorUtil.pushErrorToTeliaRumAndLog(e);
    this.accountInfoStore.setRemovalModalState(false);
    this.uiStore.showErrorNoticeFromResponse(e.response);
    this.removeEmailStatuses.set(email, FetchStatus.ERROR);
  }
}
